import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

const HEIGHT = 120;

const Base = styled.div<{ imageSrc: string }>`
  position: relative;
  height: ${HEIGHT}px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${select.color(["grey", 0])};
  background-image: url("${p => p.imageSrc}");
  background-size: cover;
  background-position: 50% 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  imageSrc?: string;
  children?: any;
};

function Top({ style, className, imageSrc, children }: Props, ref: any) {
  return (
    <Base ref={ref} imageSrc={imageSrc!} style={style} className={className}>
      {children}
    </Base>
  );
}

export default React.forwardRef(Top);
